export interface RadioField {
  label: string;
  name: string;
  type: string;
}

const PREFERENCES = ["straight", "gay", "lesbian", "trans", "animated", "fluid"];

export const FORM_FIELDS = PREFERENCES.map((name: string): RadioField => ({
  label: name.charAt(0).toUpperCase() + name.slice(1),
  name: name,
  type: "radio"
}));
